import { baseUrl, ServiceType } from 'src/contstant/apiEndpoints';
import { GBSAOrbitClient } from '@amzn/gbsa-orbit-typescript-client';

export const apiOrbitClient = new GBSAOrbitClient({
  region: 'us-west-2',
  endpoint: baseUrl(ServiceType.ORBIT),
  requestHandler: {
    credentials: 'include',
  },
});
